import { makeStyles } from 'tss-react/mui';

const useStylesCompletionBar: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  completionBar: {
    height: 7,
  },
  completionBarBackground: {
    backgroundColor: `${theme.palette.action.disabled} !important`,
  },
}));

export default useStylesCompletionBar;
